import { BrowserRouter, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./hooks/useAuth";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import UploadPage from "./pages/UploadPage";
import InvoiceDetailPage from "./pages/InvoiceDetailPage";
import RateCardsPage from "./pages/RateCardsPage";
import LookupPage from "./pages/LookupPage";
import ActivityPage from "./pages/ActivityPage";
import InvoicesPage from "./pages/InvoicesPage";
import ReportsPage from "./pages/ReportsPage";
import SurchargesPage from "./pages/SurchargesPage";
import HaulierSettingsPage from "./pages/HaulierSettingsPage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
    },
  },
});

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public */}
            <Route path="/" element={<LoginPage />} />

            {/* Protected — wrapped in Layout */}
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/upload" element={<UploadPage />} />
              <Route path="/invoices" element={<InvoicesPage />} />
              <Route path="/invoice/:id" element={<InvoiceDetailPage />} />
              <Route path="/rates" element={<RateCardsPage />} />
              <Route path="/lookup" element={<LookupPage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/surcharges" element={<SurchargesPage />} />
              <Route path="/haulier-settings" element={<HaulierSettingsPage />} />
              <Route path="/activity" element={<ActivityPage />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
